import QueryParamsUtils from "../utils/query-params.utils";
export default class DiscountHandler {
  constructor(domUtils, cartService) {
    this.domUtils = domUtils;
    this.cartService = cartService;
  }
  async init(cartContainer) {
    try {
      const form = (await this.domUtils.waitForElement(".discount-box-form", cartContainer)) || cartContainer.querySelector(".discount-box-form");
      if (!form) {
        console.error("Discount Form not loaded");
        return;
      }
      form.addEventListener("submit", e => this.#handleSubmit(e, form));
    } catch (error) {
      throw error;
    }
  }
  async #handleSubmit(e, form) {
    e.preventDefault();
    const input = form.querySelector("#slidecart_discount_code");
    if (!input) {
      return;
    }
    const code = input.value;
    QueryParamsUtils.setUrlParameter("discount_code", code);
    try {
      const result = await this.cartService.validateDiscount(code);
      if (!result || result?.error) {
        this.#hideGiftPopup();
        this.#showErrorMessage(form);
        throw new Error(`Error validating discount code ${error.message}`);
      }
      if (result?.variantIds) {
        this.#showGiftPopup();
        this.#hideErrorMessage(form);
        localStorage.setItem("removeGifts", JSON.stringify(result.variantIds));
      }
    } catch (error) {
      this.#hideGiftPopup();
      this.#showErrorMessage(form);
      throw new Error(`Error validating discount code ${error.message}`);
    }
  }
  async #hideErrorMessage(form) {
    const parent = form.parentElement;
    const span = (await this.domUtils.waitForElement("span.invalid-coupon-code", parent)) || parent.querySelector("span.invalid-coupon-code");
    if (!span) {
      throw new Error("Error: span element not found");
    }
    span.classList.add("hidden");
  }
  #showErrorMessage(form) {
    const parent = form.parentElement;
    const span = parent.querySelector("span.invalid-coupon-code");
    if (!span) {
      throw new Error("Error: span element not found");
    }
    span.classList.remove("hidden");
  }
  async #showGiftPopup() {
    const popup = await this.domUtils.waitForElement("#free-product");
    if (!popup) return;
    if (!window.popupMessage) {
      window.popupMessage = "Gifts removed";
    }
    popup.querySelector("div.gift-popup__content .gift-popup__message").textContent = window.popupMessage;
    popup.classList.remove("gift-popup--close");
  }
  async #hideGiftPopup() {
    const popup = await this.domUtils.waitForElement("#free-product");
    if (!popup) {
      throw new Error("Error: popup element not found");
    }
    if (!window.popupMessage) {
      window.popupMessage = "Gifts removed";
    }
    popup.querySelector("div.gift-popup__content .gift-popup__message").textContent = window.popupMessage;
    popup.classList.add("gift-popup--close");
  }
}